import React from "react";
import chairman from "../images/chairman.jpeg";
import principal from "../images/principal.jpeg";

const LeadershipSection = () => {
  return (
    <section className="w-full bg-gradient-to-b from-[#112E65] to-[#0b1f45] py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center text-4xl font-bold text-white mb-16">
          Leadership
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Principal */}
          <div className="bg-white rounded-tl-[50px] rounded-br-[50px] shadow-xl overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-2/5 bg-[#112E65] flex items-center justify-center p-8">
                <img
                  src={chairman}
                  alt="Mr. Bhaskar K Tompe"
                  className="w-40 h-40 rounded-full object-cover border-4 border-white shadow-lg"
                />
              </div>
              <div className="md:w-3/5 p-8 text-[#112E65]">
                <h3 className="text-2xl font-bold mb-1">Mr. Bhaskar K Tompe</h3>
                <p className="text-sm font-medium text-gray-500 mb-4">
                  Chairman
                </p>
                <p className="text-base leading-relaxed">
                 It is my privilege as President to lead an institution committed to academic excellence, innovation, ethical values, and advanced research, producing skilled pharmacy professionals through updated curricula, modern facilities, and compassionate patient-focused education to positively impact community health worldwide sustainably.
                </p>
              </div>
            </div>
          </div>

          {/* Director */}
          <div className="bg-white rounded-tr-[50px] rounded-bl-[50px] shadow-xl overflow-hidden">
            <div className="flex flex-col md:flex-row-reverse">
              <div className="md:w-2/5 bg-[#1e3a8a] flex items-center justify-center p-8">
                <img
                  src={principal}
                  alt="Dr. Rahul V Jodh"
                  className="w-40 h-40 rounded-full object-cover border-4 border-white shadow-lg"
                />
              </div>
              <div className="md:w-3/5 p-8 text-[#112E65]">
                <h3 className="text-2xl font-bold mb-1">Dr. Rahul V Jodh</h3>
                <p className="text-sm font-medium text-gray-500 mb-4">
                  Principal
                </p>
                <p className="text-base leading-relaxed">
                  We strive to develop competent pharmacy professionals through quality education, modern infrastructure, and innovation, ensuring academic excellence and comprehensive pharmaceutical care to serve community healthcare needs effectively in a competitive global environment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;
